module.exports = __webpack_public_path__ + "img/circle-dot.f9a33cbf.svg";